import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    DtgListType
} from "src/app/shared/vo";

@Component({
  templateUrl: "./dtg.manage.car.search.component.html"
  ,styleUrls: ["./dtg.manage.car.search.component.scss"]
})
export class DtgManageCarSearchComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    listItem:any[];
    DtgListType = DtgListType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    callbackSelectCar(carInfo:any){
        this.clickSelectCar(carInfo);
    }

    clickSelectCar(carInfo:any){
        this.activeModal.close({
            "result":"ok"
            ,"carInfo":carInfo
        });
    }
}
